import { render, staticRenderFns } from "./LessonView.vue?vue&type=template&id=7b632078&"
import script from "./LessonView.vue?vue&type=script&lang=ts&"
export * from "./LessonView.vue?vue&type=script&lang=ts&"
import style0 from "./LessonView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports